import React from 'react';
import { Col } from 'antd';

import { formatarDataCorrida } from '../../../helpers/formatarDataFila';
import { ColTop } from './ColTop';
import { ColButtom } from './ColButtom';

export function Indicadores({
  indicResponse,
  indicAnalise,
  spinningIndicadores,
}) {
  const indicadorSuperior = {
    tempoMedioAtendimento:
      formatarDataCorrida(indicResponse?.tempoMedioAtendimento) || '00:00:00',
    totalAtendimento: indicResponse?.quantidadeAtendimentos || 0,
  };

  const indicadorInferior = {
    ...indicResponse,
    atendimentoEmAndamento: indicAnalise?.emAnalise || 0,
    tempoMaxAtendimento:
      formatarDataCorrida(indicAnalise?.atendimentoMax) || '00:00:00',
  };

  return (
    <Col
      justify="space-between"
      align="middle"
      style={{
        marginTop: '13px',
      }}
      id="indicadores"
    >
      <ColTop
        loading={spinningIndicadores}
        indicResponse={indicResponse}
        data={indicadorSuperior}
      />
      <ColButtom
        loading={spinningIndicadores}
        data={indicadorInferior}
      />
    </Col>
  );
}
